import { call, put, select, takeLatest } from "redux-saga/effects";

import { EntityType } from "@mapmycustomers/shared/enum";
import { Company, MapEntity, Person } from "@mapmycustomers/shared/types/entity";
import Organization from "@mapmycustomers/shared/types/Organization";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { getOrganizationId } from "@app/store/iam/selectors";

import { fetchSelectionEntities } from "./actions";

export function* onFetchSelectionEntities({ payload }: ReturnType<typeof fetchSelectionEntities>) {
  try {
    const { accountIds, contactIds } = payload;
    if (accountIds.length === 0 && contactIds.length === 0) {
      yield call(payload.callback, []);
      return;
    }
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const entities: Record<string, unknown> = {};
    const addEntityFilter = (entityType: EntityType, ids: Company["id"][]) => {
      if (ids.length > 0) {
        entities[entityType] = { $and: [{ id: { $in: ids } }], includeGroups: true };
      }
    };
    addEntityFilter(EntityType.COMPANY, accountIds);
    addEntityFilter(EntityType.PERSON, contactIds);
    const response: ListResponse<MapEntity> = yield callApi("fetchPins", orgId, {
      $filters: { entities },
      $limit: accountIds.length + contactIds.length,
    });
    yield call(payload.callback, response.data as (Company | Person)[]);
  } catch (error) {
    yield put(handleError({ error }));
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
  }
}

export function* selectionEntitiesSagas() {
  yield takeLatest(fetchSelectionEntities, onFetchSelectionEntities);
}
